export default __webpack_public_path__ + "64c0fb86eaa71469843209dda6e52684.webm";